<template>
  <v-card class="mt-3">
    <v-row>
      <v-col cols="12">
        <div style="padding-left: 15px; padding-bottom:10px">
          <span v-html="cmsOfferRequested.content"></span>         
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  components: {
  },
  setup(props, context) {
    const api = context.root.$api

    const cmsOfferRequestedModel  = api.resource('portal/cms-contents/search').model()

    cmsOfferRequestedModel.find('offer_requested').catch(() => {
      console.log( 'not found')
    })

    const { attributes: cmsOfferRequested}  = cmsOfferRequestedModel

    return {
      cmsOfferRequested
    }
  },
}
</script>

<style scoped>

</style>